import { render, staticRenderFns } from "./LicenseGroupList.vue?vue&type=template&id=648ebba2&"
import script from "./LicenseGroupList.vue?vue&type=script&lang=js&"
export * from "./LicenseGroupList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('648ebba2')) {
      api.createRecord('648ebba2', component.options)
    } else {
      api.reload('648ebba2', component.options)
    }
    module.hot.accept("./LicenseGroupList.vue?vue&type=template&id=648ebba2&", function () {
      api.rerender('648ebba2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/policy/LicenseGroupList.vue"
export default component.exports